import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() {}

  readonly PRIMARY_COLOR_TAG: string = 'primaryColor';
  readonly PRIMARY_TEXT_COLOR_TAG: string = 'primaryTextColor';
  readonly SECONDARY_COLOR_TAG: string = 'secondaryColor';
  readonly SECONDARY_TEXT_COLOR_TAG: string = 'secondaryTextColor';
  readonly LANG_TAG: string = 'lang';
  readonly COUNTRY_TAG: string = 'country';
  readonly FONT_TAG: string = 'font';
  readonly TEXT_COLOR_TAG: string = 'textColor';
  readonly TITLE_TEXT_COLOR_TAG: string = 'titleTextColor';
  readonly COMPANY_LOGO_URL_TAG: string = 'companyLogoUrl';
  readonly BACKGROUND_URL_TAG: string = 'backgroundUrl';
  readonly LOGIN_ID_TAG: string = 'loginId';
  readonly EXPIRE_TAG: string = 'expire';
  readonly CULTURE_TAG: string = 'culture';  

  public getBackgroundUrl(): string {
    return localStorage.getItem(this.BACKGROUND_URL_TAG);
  }

  public getCompanyLogoUrl(): string {
    return localStorage.getItem(this.COMPANY_LOGO_URL_TAG);
  }

  public setPrimaryColor(value) {
    localStorage.setItem(this.PRIMARY_COLOR_TAG, value);
  }

  public getPrimaryColor(): string {
    return localStorage.getItem(this.PRIMARY_COLOR_TAG);
  }

  public getPrimaryTextColor(): string {
    return localStorage.getItem(this.PRIMARY_TEXT_COLOR_TAG);
  }

  public setSecondaryColor(value) {
    localStorage.setItem(this.SECONDARY_COLOR_TAG, value);
  }

  public getSecondaryColor(): string {
    return localStorage.getItem(this.SECONDARY_COLOR_TAG);
  }

  public getSecondaryTextColor(): string {
    return localStorage.getItem(this.SECONDARY_TEXT_COLOR_TAG);
  }

  public getFont(): string {
    return localStorage.getItem(this.FONT_TAG);
  }

  public getTextColor(): string {
    return localStorage.getItem(this.TEXT_COLOR_TAG);
  }

  public getTitleTextColor(): string {
    return localStorage.getItem(this.TITLE_TEXT_COLOR_TAG);
  }

  public getLoginId(): string {
    return localStorage.getItem(this.LOGIN_ID_TAG);
  }
  
  public getCulture(): string {
    return localStorage.getItem(this.CULTURE_TAG);
  }

  public setLoginId(value) {
    localStorage.setItem(this.LOGIN_ID_TAG, value);
  }

  public setExpire(value) {
    localStorage.setItem(this.EXPIRE_TAG, value);
  }

  public setCulture(value) {
    localStorage.setItem(this.CULTURE_TAG, value);
  }

  public deleteExpire() {
    localStorage.removeItem(this.EXPIRE_TAG);
  }

  public deleteLoginId() {
    localStorage.removeItem(this.LOGIN_ID_TAG);
  }
}